<template>
    <div class="d-flex justify-content-between w-100 h-100 align-items-center flex-column pt-3 pb-5">
        <div class="d-flex flex-column align-items-center pt-3 p-l-45 p-r-45">
            <div class="h5">{{ $t("lbl_emp2_MembershipsBenefitsTitle") }}</div>
            <div class="text-desciption supplier_MembershipsBenefits_description"
                v-html="$t('lbl_emp2_MembershipsBenefitsDescription')"></div>
        </div>
        <div class="pt-3 pb-3">
            <div v-html="$t('lbl_emp2_PromotionOpp_table')"></div>
            <div class="text-center">
                {{ $t("lbl_emp2_PromotionOpportunitiesRemarks") }}
            </div>
        </div>
        <div class="pt-3 pb-4">
            <table class="supplier_MembershipsBenefitsTable">
                <tbody>
                    <tr>
                        <th></th>
                        <th class="text-center">
                            <div class="supplier_MembershipsBenefitsTable_MemberDiv">
                                <i class="fa fa-star supplier_MembershipsBenefitsTable_MemberIcon purpleMember"></i>
                                <div class="supplier_MembershipsBenefitsTable_MemberType"
                                    v-html='$t("lbl_emp2_StarEnterprise")'></div>
                            </div>
                        </th>
                        <th class="text-center">
                            <div class="supplier_MembershipsBenefitsTable_MemberDiv">
                                <i class="fa fa-star supplier_MembershipsBenefitsTable_MemberIcon greenMember"></i>
                                <div class="supplier_MembershipsBenefitsTable_MemberType"
                                    v-html='$t("lbl_emp2_ProfessionalMember")'></div>
                            </div>
                        </th>
                        <th class="text-center">
                            <div class="supplier_MembershipsBenefitsTable_MemberDiv">
                                <i class="fa fa-star supplier_MembershipsBenefitsTable_MemberIcon orangeMember"></i>
                                <div class="supplier_MembershipsBenefitsTable_MemberType"
                                    v-html='$t("lbl_emp2_BasicMember2")'></div>
                            </div>
                        </th>
                        <th class="text-center">
                            <div class="supplier_MembershipsBenefitsTable_MemberDiv">
                                <i class="fa fa-star supplier_MembershipsBenefitsTable_MemberIcon blackMember"></i>
                                <div class="supplier_MembershipsBenefitsTable_MemberType"
                                    v-html='$t("lbl_emp2_FreeTrialMember")'></div>
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <td class="supplier_MembershipsBenefitsTable_item">{{ $t("lbl_emp2_MembershipBenefitsTable2_Item1")
                        }}</td>
                        <td class="tablecontent_right text-center">{{ $t('lbl_emp2_eBoothA') }}</td>
                        <td class="tablecontent_right text-center">{{ $t('lbl_emp2_eBoothBC') }}</td>
                        <td class="tablecontent_right text-center">{{ $t('lbl_emp2_BasicEbooth') }}</td>
                        <td class="tablecontent_right text-center">{{ $t('lbl_emp2_TrialEBooth') }}</td>
                    </tr>
                    <tr>
                        <td class="supplier_MembershipsBenefitsTable_item">{{ $t("lbl_emp2_MembershipBenefitsTable2_Item2")
                        }}
                        </td>
                        <td class="tablecontent_right text-center">{{ $t('lbl_emp2_CanUploadNProducts').replace("{0}", "50") }}</td>
                        <td class="tablecontent_right text-center">{{ $t('lbl_emp2_CanUploadMaxNProducts').replace("{0}", "25") }}</td>
                        <td class="tablecontent_right text-center">{{ $t('lbl_emp2_CanUploadNProducts').replace("{0}", "8") }}</td>
                        <td class="tablecontent_right text-center">{{ $t('lbl_emp2_CanUploadNProducts').replace("{0}", "3") }}</td>
                    </tr>
                    <tr>
                        <td class="supplier_MembershipsBenefitsTable_item">{{ $t("lbl_emp2_MembershipBenefitsTable2_Item3")
                        }}
                        </td>
                        <td class="tablecontent_right text-center"><span
                                class="fa fa-check supplier_MembershipsBenefitsTable_item_tick"></span></td>
                        <td class="tablecontent_right text-center"><span
                                class="fa fa-check supplier_MembershipsBenefitsTable_item_tick"></span></td>
                        <td class="tablecontent_right text-center"><span
                                class="fa fa-check supplier_MembershipsBenefitsTable_item_tick"></span></td>
                        <td class="tablecontent_right text-center"></td>
                    </tr>
                    <tr>
                        <td class="supplier_MembershipsBenefitsTable_item">{{ $t("lbl_emp2_MembershipBenefitsTable2_Item4")
                        }}
                        </td>
                        <td class="tablecontent_right text-center"><span
                                class="fa fa-check supplier_MembershipsBenefitsTable_item_tick"></span></td>
                        <td class="tablecontent_right text-center"><span
                                class="fa fa-check supplier_MembershipsBenefitsTable_item_tick"></span></td>
                        <td class="tablecontent_right text-center"><span
                                class="fa fa-check supplier_MembershipsBenefitsTable_item_tick"></span></td>
                        <td class="tablecontent_right text-center"></td>
                    </tr>
                    <tr>
                        <td class="supplier_MembershipsBenefitsTable_item">{{ $t("lbl_emp2_MembershipBenefitsTable2_Item5")
                        }}
                        </td>
                        <td class="tablecontent_right text-center"><span
                                class="fa fa-check supplier_MembershipsBenefitsTable_item_tick"></span></td>
                        <td class="tablecontent_right text-center"><span
                                class="fa fa-check supplier_MembershipsBenefitsTable_item_tick"></span></td>
                        <td class="tablecontent_right text-center"></td>
                        <td class="tablecontent_right text-center"></td>
                    </tr>
                    <tr>
                        <td class="supplier_MembershipsBenefitsTable_item">{{ $t("lbl_emp2_MembershipBenefitsTable2_Item6")
                        }}
                        </td>
                        <td class="tablecontent_right text-center"><span
                                class="fa fa-check supplier_MembershipsBenefitsTable_item_tick"></span></td>
                        <td class="tablecontent_right text-center"><span
                                class="fa fa-check supplier_MembershipsBenefitsTable_item_tick"></span></td>
                        <td class="tablecontent_right text-center"></td>
                        <td class="tablecontent_right text-center"></td>
                    </tr>
                    <tr>
                        <td class="supplier_MembershipsBenefitsTable_item">{{ $t("lbl_emp2_MembershipBenefitsTable2_Item7")
                        }}
                        </td>
                        <td class="tablecontent_right text-center"><span
                                class="fa fa-check supplier_MembershipsBenefitsTable_item_tick"></span></td>
                        <td class="tablecontent_right text-center"></td>
                        <td class="tablecontent_right text-center"></td>
                        <td class="tablecontent_right text-center"></td>
                    </tr>
                    <tr>
                        <td class="supplier_MembershipsBenefitsTable_item">{{ $t("lbl_emp2_MembershipBenefitsTable2_Item8")
                        }}
                        </td>
                        <td class="tablecontent_right text-center"><span
                                class="fa fa-check supplier_MembershipsBenefitsTable_item_tick"></span></td>
                        <td class="tablecontent_right text-center"><span
                                class="fa fa-check supplier_MembershipsBenefitsTable_item_tick"></span></td>
                        <td class="tablecontent_right text-center"></td>
                        <td class="tablecontent_right text-center"></td>
                    </tr>
                    <tr>
                        <td class="supplier_MembershipsBenefitsTable_item">{{ $t("lbl_emp2_MembershipBenefitsTable2_Item9")
                        }}
                        </td>
                        <td class="tablecontent_right text-center"><span
                                class="fa fa-check supplier_MembershipsBenefitsTable_item_tick"></span></td>
                        <td class="tablecontent_right text-center"></td>
                        <td class="tablecontent_right text-center"></td>
                        <td class="tablecontent_right text-center"></td>
                    </tr>
                    <tr>
                        <td class="supplier_MembershipsBenefitsTable_item">{{ $t("lbl_emp2_MembershipBenefitsTable2_Item10")
                        }}
                        </td>
                        <td class="tablecontent_right text-center"><span
                                class="fa fa-check supplier_MembershipsBenefitsTable_item_tick"></span></td>
                        <td class="tablecontent_right text-center"><span
                                class="fa fa-check supplier_MembershipsBenefitsTable_item_tick"></span></td>
                        <td class="tablecontent_right text-center"></td>
                        <td class="tablecontent_right text-center"></td>
                    </tr>
                </tbody>
            </table>
            <div class="text-center">
                {{ $t("lbl_emp2_MembershipBenefitsTable2_Remark") }}
            </div>
            <div class="text-center mt-3">
                <a class="btn btn-danger" target="_blank" :href="JoinMemberUrl"
                    t_label="link_empbe_SupplierMembershipsBenefits_JoinMember">
                    {{ $t("lbl_emp2_JoinMemberPageButton") }}
                </a>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            JoinMemberUrl: 'https://www.chinaplasonline.com/eMarketplace/JoinMember/' + localStorage.getItem("currentLang") + '/?regsource=EMPBE_MembershipsAndBenefitsBtn'
        }
    }
}
</script>
<style>
.pricingtable .price-value {
    padding: 25px 0 0 !important;
}

.supplier_MembershipsBenefits_PromotionOpportunitiesTable,
.supplier_MembershipsBenefits_description {
    /* width: 970px; */
}

.supplier_MembershipsBenefits_PromotionOpportunitiesTable a {
    color: #000000;
}

.supplier_MembershipsBenefits_PromotionOpportunitiesTable,
.supplier_MembershipsBenefitsTable {
    margin-bottom: 10px;
}

.supplier_MembershipsBenefits_PromotionOpportunitiesTable .header {
    background-color: #5D4D8C;
    color: #FFFFFF;
    text-align: center;
    padding: 10px 0px;
}

.supplier_MembershipsBenefits_PromotionOpportunitiesTable td {
    color: #000000;
    padding: 15px 80px 20px 35px;
}

.supplier_MembershipsBenefits_PromotionOpportunitiesTable .tablecontent_right {
    border-left: #D9D9D9 2px solid;
    margin-right: 40px !important;
}

.supplier_MembershipsBenefits_PromotionOpportunitiesTable tr:nth-child(even),
.supplier_MembershipsBenefitsTable tr:nth-child(even) {
    background-color: #FFFFFF;
}

.supplier_MembershipsBenefitsTable_MemberDiv {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 10px 0px;
    width: 150px;
}

.supplier_MembershipsBenefitsTable_MemberIcon {
    font-size: 40px;
    padding: 10px;
}

.supplier_MembershipsBenefitsTable_MemberType {
    text-align: center;
    font-size: 16px;
    text-transform: uppercase;
}

.greenMember {
    color: #A9DD15;
}

.supplier_MembershipsBenefitsTable_item {
    padding: 15px 35px 20px 35px;
    max-width: 410px;
}

.supplier_MembershipsBenefitsTable .tablecontent_right {
    border-left: #D9D9D9 2px solid;
}

.supplier_MembershipsBenefitsTable_item_tick {
    color: #696969;
    padding: 0px 45px;
    font-size: 20px;
}

@media (max-width: 992px) {
    .supplier_MembershipsBenefits_PromotionOpportunitiesTable {
        width: initial;
    }

    .supplier_MembershipsBenefits_PromotionOpportunitiesTable td {
        padding: 15px 35px 20px 35px !important;
    }

    .supplier_MembershipsBenefitsTable_MemberType {
        font-size: 12px !important;
    }

    .supplier_MembershipsBenefitsTable_item_tick {
        padding: 0px 20px !important;
    }
}

@media (max-width: 576px) {
    .supplier_MembershipsBenefitsTable_item {
        padding: 15px 10px 20px 15px !important;
    }
}

.bg-grey {
    background-color: #F8F8F8 !important;
}

.blackMember {
    color: #000000;
}

.purpleMember {
    color: #5D4D8C;
}

.greenMember {
    color: #A9DD15;
}

.redMember {
    color: #CB242B;
}

.orangeMember {
    color: #E98024;
}
</style>